import PropTypes from 'prop-types';
import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

const styles = {
  progress: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'none',
  },
};

const BusyFlatButton = props => {
  const { busy, labels, disabled, progressColor, ...otherProps } = props;
  return (
    <FlatButton
      disabled={busy || disabled}
      {...otherProps}
      label={labels[Number(busy)]}
    >
      { busy &&
      <LinearProgress
        mode="indeterminate"
        style={styles.progress}
        color={progressColor}
      />
      }
    </FlatButton>
  );
};

BusyFlatButton.defaultProps = {
  busy: false,
  labels: ['ok', 'busy'],
  progressColor: ''
};

BusyFlatButton.propTypes = {
  busy: PropTypes.bool.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default BusyFlatButton;